import { CLink } from './CLink.js';

const CCLinkPlugin = {
    install: (app) => {
        app.component(CLink.name, CLink);
    },
};

export { CCLinkPlugin, CLink };
//# sourceMappingURL=index.js.map
